module.exports = __webpack_public_path__ + "img/logo-canoa-aventura.d36caa45.png";